import React from "react";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { TEXT_SECONDARY } from "design-system/colors";
import { bool, func, string } from "prop-types";

import SEModal from "src/shared/components/SEModal";
import { useIsMobile } from "src/shared/utilities/customHooks";

import ModalContent from "../VoucherModal/ModalContent";
import * as S from "./styled";

const VoucherModal = props => {
  const { isOpen, onRequestClose, rootElementId } = props;
  const topPadding = useIsMobile() ? "0px" : "120px";

  return (
    <SEModal
      dialogStyles={{
        top: topPadding
      }}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      rootElementId={rootElementId}
    >
      <ModalContent />
      <S.CloseButtonContainer>
        <XButton color={TEXT_SECONDARY} onClick={onRequestClose} />
      </S.CloseButtonContainer>
    </SEModal>
  );
};

VoucherModal.propTypes = {
  isOpen: bool.isRequired,
  onRequestClose: func,
  rootElementId: string
};

VoucherModal.defaultProps = {
  onRequestClose: () => {},
  rootElementId: ""
};

export default VoucherModal;
